import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  imagestyles: ['hero_lg', 'hero_md', 'hero_sm', 'hero_xs', 'link_lg', 'link_md', 'link_sm', 'link_xs', 'paragraph_text_image_lg',
                'paragraph_text_image_md', 'paragraph_text_image_sm', 'paragraph_text_image_xs', 'team_lg', 'team_md', 'team_sm', 'team_xs',
                'slider_xxl', 'slider_xl', 'slider_lg', 'slider_md', 'slider_sm', 'slider_xs', 'pf_xxl', 'pf_xl', 'pf_lg', 'pf_md', 'pf_sm', 'pf_xs',
                'poster_small', 'poster_large'],
  language: $cookies.get('zdpLangCode') ? $cookies.get('zdpLangCode').toLowerCase() : ((navigator.language
    || navigator.userLanguage).toString().indexOf('de') < 0 ? 'EN' : 'DE'),
};

const mutations = {
  setLanguage(state, payload) {
    state.language = payload;
  }
};

export default new Vuex.Store({
  state, mutations
});

